import { render, staticRenderFns } from "./ModalProgramBuilding.vue?vue&type=template&id=72c2fcc8&scoped=true"
import script from "./ModalProgramBuilding.vue?vue&type=script&lang=js"
export * from "./ModalProgramBuilding.vue?vue&type=script&lang=js"
import style0 from "./ModalProgramBuilding.vue?vue&type=style&index=0&id=72c2fcc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c2fcc8",
  null
  
)

export default component.exports